export default {
  STUDENT: 'student',
  GROUP_LEADER: 'group-leader',
  NETWORK_LEADER: 'network-leader',
  ADMIN: 'admin'
}